import FactoryIcon from './FactoryIcon';

export default FactoryIcon;
